import { render, staticRenderFns } from "./PartnerCreate2.vue?vue&type=template&id=3e95c044&scoped=true"
import script from "./PartnerCreate2.vue?vue&type=script&lang=js"
export * from "./PartnerCreate2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e95c044",
  null
  
)

export default component.exports